import NATIONALITIES from "./nationalities.json";

// Add Edit Contact form
export const CONFIG = {
  tablePG: [50, 100, { text: "All", value: -1 }],
  permissions:{
    //Router permissions
    home: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],
    agents: ["sadmin", "admin", "entry"],
    employers: ["sadmin", "admin", "processing"],
    projects: ["sadmin", "admin", "entry"],
    project_medicals: ["sadmin", "admin", "entry"],
    project_visas: ["sadmin", "admin", "processing"],
    project_biometrics: ["sadmin", "admin", "processing"],
    project_bmet_statuses: ["sadmin", "admin", "manpower"],
    project_flights: ["sadmin", "admin", "manpower"],
    project_service_charges: ["sadmin", "admin", "accountant"],
    trades: ["sadmin", "admin", "processing"],
    visa_numbers: ["sadmin", "admin", "processing"],
    expenses: ["sadmin", "admin", "accountant"],
    account_heads: ["sadmin", "admin", "accountant"],
    investments: ["sadmin", "admin", "accountant"],

    agent_receive_payments_history: ["sadmin", "admin", "accountant"],
    daily_expense_report: ["sadmin", "admin", "accountant"],
    daily_received_report: ["sadmin", "admin", "accountant"],
    invoice_dues_report: ["sadmin", "admin", "accountant"],
    monthly_profit_loss: ["sadmin", "admin", "accountant"],
    projects_report: ["sadmin", "admin", "accountant"],
    invest_report: ["sadmin", "admin", "accountant"],

	//Entry Dept. Reports
    entry_agent_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],
    entry_company_wise_candidate_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],
    entry_total_candidate_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],
    entry_candidate_medical_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],

	//Processing Dept. Reports
    processing_company_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],
    processing_mofa_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],
    processing_total_embassy_submit_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],

	//Manpower Dept. Reports
    manpower_training_n_finger_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],
    manpower_complete_status_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],
    manpower_flight_complete_report: ["sadmin", "admin", "entry", "processing", "manpower", "accountant"],

    //Features permissions
    agent_add: ["sadmin", "admin", "entry"],
    agent_edit: ["sadmin", "admin"],
    agent_del: ["sadmin", "admin"],

    employer_add: ["sadmin", "admin", "entry"],
    employer_edit: ["sadmin", "admin"],
    employer_del: ["sadmin", "admin"],
    
    project_add: ["sadmin", "admin", "entry"],
    project_edit: ["sadmin", "admin", "entry", "processing", "accountant"],
    project_del: ["sadmin", "admin"],

    expense_add: ["sadmin", "admin", "accountant"],
    expense_edit: ["sadmin", "admin"],
    expense_del: ["sadmin", "admin"],

    account_head_add: ["sadmin", "admin"],
    account_head_edit: ["sadmin", "admin"],
    account_head_del: ["sadmin", "admin"],
  }
};

export const GENDERS = ["male", "female", "other"];
export const RELIGIONS = [
  { text: "Islam", value: "Islam" },
  { text: "Hindu", value: "Hindu"},
  { text: "Buddhist", value: "Buddhist" },
  { text: "Christian", value: "Christian"}
];

export const MARITAL_STATUSES = [
  { text: "Single", value: "Single" },
  { text: "Married", value: "Married"}
];

// List of all countries in a simple list / array.
// Sorted alphabetical by country name (special characters on bottom)
export const COUNTRIES = [
	"Afghanistan",
	"Albania",
	"Algeria",
	"American Samoa",
	"Andorra",
	"Angola",
	"Anguilla",
	"Antarctica",
	"Antigua and Barbuda",
	"Argentina",
	"Armenia",
	"Aruba",
	"Australia",
	"Austria",
	"Azerbaijan",
	"Bahamas (the)",
	"Bahrain",
	"Bangladesh",
	"Barbados",
	"Belarus",
	"Belgium",
	"Belize",
	"Benin",
	"Bermuda",
	"Bhutan",
	"Bolivia (Plurinational State of)",
	"Bonaire, Sint Eustatius and Saba",
	"Bosnia and Herzegovina",
	"Botswana",
	"Bouvet Island",
	"Brazil",
	"British Indian Ocean Territory (the)",
	"Brunei Darussalam",
	"Bulgaria",
	"Burkina Faso",
	"Burundi",
	"Cabo Verde",
	"Cambodia",
	"Cameroon",
	"Canada",
	"Cayman Islands (the)",
	"Central African Republic (the)",
	"Chad",
	"Chile",
	"China",
	"Christmas Island",
	"Cocos (Keeling) Islands (the)",
	"Colombia",
	"Comoros (the)",
	"Congo (the Democratic Republic of the)",
	"Congo (the)",
	"Cook Islands (the)",
	"Costa Rica",
	"Croatia",
	"Cuba",
	"Curaçao",
	"Cyprus",
	"Czechia",
	"Côte d'Ivoire",
	"Denmark",
	"Djibouti",
	"Dominica",
	"Dominican Republic (the)",
	"Ecuador",
	"Egypt",
	"El Salvador",
	"Equatorial Guinea",
	"Eritrea",
	"Estonia",
	"Eswatini",
	"Ethiopia",
	"Falkland Islands (the) [Malvinas]",
	"Faroe Islands (the)",
	"Fiji",
	"Finland",
	"France",
	"French Guiana",
	"French Polynesia",
	"French Southern Territories (the)",
	"Gabon",
	"Gambia (the)",
	"Georgia",
	"Germany",
	"Ghana",
	"Gibraltar",
	"Greece",
	"Greenland",
	"Grenada",
	"Guadeloupe",
	"Guam",
	"Guatemala",
	"Guernsey",
	"Guinea",
	"Guinea-Bissau",
	"Guyana",
	"Haiti",
	"Heard Island and McDonald Islands",
	"Holy See (the)",
	"Honduras",
	"Hong Kong",
	"Hungary",
	"Iceland",
	"India",
	"Indonesia",
	"Iran (Islamic Republic of)",
	"Iraq",
	"Ireland",
	"Isle of Man",
	"Israel",
	"Italy",
	"Jamaica",
	"Japan",
	"Jersey",
	"Jordan",
	"Kazakhstan",
	"Kenya",
	"Kiribati",
	"Korea (the Democratic People's Republic of)",
	"Korea (the Republic of)",
	"Kuwait",
	"Kyrgyzstan",
	"Lao People's Democratic Republic (the)",
	"Latvia",
	"Lebanon",
	"Lesotho",
	"Liberia",
	"Libya",
	"Liechtenstein",
	"Lithuania",
	"Luxembourg",
	"Macao",
	"Madagascar",
	"Malawi",
	"Malaysia",
	"Maldives",
	"Mali",
	"Malta",
	"Marshall Islands (the)",
	"Martinique",
	"Mauritania",
	"Mauritius",
	"Mayotte",
	"Mexico",
	"Micronesia (Federated States of)",
	"Moldova (the Republic of)",
	"Monaco",
	"Mongolia",
	"Montenegro",
	"Montserrat",
	"Morocco",
	"Mozambique",
	"Myanmar",
	"Namibia",
	"Nauru",
	"Nepal",
	"Netherlands (the)",
	"New Caledonia",
	"New Zealand",
	"Nicaragua",
	"Niger (the)",
	"Nigeria",
	"Niue",
	"Norfolk Island",
	"Northern Mariana Islands (the)",
	"Norway",
	"Oman",
	"Pakistan",
	"Palau",
	"Palestine, State of",
	"Panama",
	"Papua New Guinea",
	"Paraguay",
	"Peru",
	"Philippines (the)",
	"Pitcairn",
	"Poland",
	"Portugal",
	"Puerto Rico",
	"Qatar",
	"Republic of North Macedonia",
	"Romania",
	"Russian Federation (the)",
	"Rwanda",
	"Réunion",
	"Saint Barthélemy",
	"Saint Helena, Ascension and Tristan da Cunha",
	"Saint Kitts and Nevis",
	"Saint Lucia",
	"Saint Martin (French part)",
	"Saint Pierre and Miquelon",
	"Saint Vincent and the Grenadines",
	"Samoa",
	"San Marino",
	"Sao Tome and Principe",
	"Saudi Arabia",
	"Senegal",
	"Serbia",
	"Seychelles",
	"Sierra Leone",
	"Singapore",
	"Sint Maarten (Dutch part)",
	"Slovakia",
	"Slovenia",
	"Solomon Islands",
	"Somalia",
	"South Africa",
	"South Georgia and the South Sandwich Islands",
	"South Sudan",
	"Spain",
	"Sri Lanka",
	"Sudan (the)",
	"Suriname",
	"Svalbard and Jan Mayen",
	"Sweden",
	"Switzerland",
	"Syrian Arab Republic",
	"Taiwan",
	"Tajikistan",
	"Tanzania, United Republic of",
	"Thailand",
	"Timor-Leste",
	"Togo",
	"Tokelau",
	"Tonga",
	"Trinidad and Tobago",
	"Tunisia",
	"Turkey",
	"Turkmenistan",
	"Turks and Caicos Islands (the)",
	"Tuvalu",
	"Uganda",
	"Ukraine",
	"United Arab Emirates (the)",
	"United Kingdom of Great Britain and Northern Ireland (the)",
	"United States Minor Outlying Islands (the)",
	"United States of America (the)",
	"Uruguay",
	"Uzbekistan",
	"Vanuatu",
	"Venezuela (Bolivarian Republic of)",
	"Viet Nam",
	"Virgin Islands (British)",
	"Virgin Islands (U.S.)",
	"Wallis and Futuna",
	"Western Sahara",
	"Yemen",
	"Zambia",
	"Zimbabwe",
	"Åland Islands"
];

export const LANGUAGES = [
  {"name": "Arabic", "code": "ar"},  
  {"name": "Bengali", "code": "bn"},  
  {"name": "Chinese", "code": "zh"},  
  {"name": "Danish", "code": "da"},
  {"name": "Dutch", "code": "nl"},
  {"name": "English", "code": "en"},  
  {"name": "French", "code": "fr"},  
  {"name": "German", "code": "de"},  
  {"name": "Greek", "code": "el"}, 
  {"name": "Hindi", "code": "hi"},  
  {"name": "Indonesian", "code": "id"},  
  {"name": "Italian", "code": "it"},  
  {"name": "Japanese", "code": "ja"},  
  {"name": "Spanish", "code": "es"},  
  {"name": "Turkish", "code": "tr"},
]

// export const BUSINESS_TYPES = ["client", "loan", "employee", "purchase"];
// export const CONTACT_TYPES = ["individual", "company"];
export const NAV_MENU_REPORTS = {
  icon: "bar_chart",
  title: "Reports",
  router_name: "daily_expense_report",
  perm: ["sadmin","admin"],
  items: [
    {
      icon: "dynamic_feed",
      title: "Agent Receive & Payments",
      router_name: "agent_receive_payments_history",
    },
    {
      icon: "dynamic_feed",
      title: "Daily Expense",
      router_name: "daily_expense_report",
      // perm: ["sadmin","admin"],
    },
    {
      icon: "arrow_circle_up",
      title: "Daily Received",
      router_name: "daily_received_report",
      // perm: ["sadmin","admin"],
    },
    {
      icon: "dynamic_feed",
      title: "Dues Report",
      router_name: "invoice_dues_report",
      // perm: ["sadmin","admin"],
    },
    {
      icon: "arrow_circle_up",
    //   title: "Profit & Loss",
      title: "Balance On",
      router_name: "monthly_profit_loss",
    },
    {
      icon: "arrow_circle_up",
      title: "Projects Report",
      router_name: "projects_report",
      // perm: ["sadmin","admin"],
    },
    {
      icon: "arrow_circle_up",
      title: "Invest Report",
      router_name: "invest_report",
      // perm: ["sadmin","admin"],
    },
  ],
};

export const NAV_MENU_ENTRY_REPORTS = {
  icon: "bar_chart",
  title: "Entry Reports",
  router_name: "daily_expense_report",
  perm: ["sadmin","admin"],
  items: [
    {
      icon: "dynamic_feed",
      title: "Agent Report",
      router_name: "entry_agent_report",
    },
    {
      icon: "dynamic_feed",
      title: "Company wise candidate",
      router_name: "entry_company_wise_candidate_report",
    },
    {
      icon: "dynamic_feed",
      title: "Total candidate",
      router_name: "entry_total_candidate_report",
    },
    {
      icon: "dynamic_feed",
      title: "Candidate Medical",
      router_name: "entry_candidate_medical_report",
    },
  ],
};

export const NAV_MENU_PROCESSING_REPORTS = {
  icon: "bar_chart",
  title: "Processing Reports",
  router_name: "daily_expense_report",
  perm: ["sadmin","admin"],
  items: [
    {
      icon: "dynamic_feed",
      title: "Company/Sponsor Report",
      router_name: "processing_company_report",
    },
    {
      icon: "dynamic_feed",
      title: "Mofa Report",
      router_name: "processing_mofa_report",
    },
    {
      icon: "dynamic_feed",
      title: "Embassy Submit Report",
      router_name: "processing_total_embassy_submit_report",
    }
  ],
};

export const NAV_MENU_MANPOWER_REPORTS = {
  icon: "bar_chart",
  title: "Manpower Reports",
  router_name: "daily_expense_report",
  perm: ["sadmin","admin"],
  items: [
    {
      icon: "dynamic_feed",
      title: "Training & Finger Report",
      router_name: "manpower_training_n_finger_report",
    },
    {
      icon: "dynamic_feed",
      title: "Manpower Status Report",
      router_name: "manpower_complete_status_report",
    },
    {
      icon: "dynamic_feed",
      title: "Flight Report",
      router_name: "manpower_flight_complete_report",
    }
  ],
};

export const DAY_NAMES = ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
export const MYSQL_DATETIME_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const MYSQL_DATE_FORMAT = "YYYY-MM-DD";
export const MYSQL_TIME_FORMAT = "HH:mm:ss";
export const DATE_FORMAT = "DD/MM/YYYY";
export const TIME_FORMAT = "hh:mm a";

// Manpower start

export const MEDICAL_STATUSES = [
  // { value: "in_office", text: "Submmit in Office" },
  // { value: "in_medical", text: "Submmit In Medical" },
  { value: "Fit", text: "Fit" },
  { value: "Unfit", text: "Unfit" },
  { value: "Meet", text: "Meet" },
];
export const FINGER_STATUSES = [
  { value: "completed", text: "Completed" },
  { value: "incomplete", text: "Incomplete" }
];

export const VISA_TYPES = [
  {text: "LABOUR", value: "labour"},
  {text: "FACTORY WORKER", value: "factory_worker"},
  {text: "CLEANING WORKER", value: "cleaning_worker"},
  {text: "SCAFFOLDER", value: "scaffolder"},
  {text: "SCAFFOLDER", value: "scaffolder"},
  {text: "MASON", value: "mason"},
  {text: "CONTRACT LABOUR", value: "contract_labour"},
  {text: "KITCHEN CLEANER", value: "kitchen_cleaner"},
  {text: "S/FIXER", value: "s_fixer"},
];


export const SERVICE_TYPES = [
  {text: "VISA PROCESSING", value: "processing"},
  {text: "VISA WORKING", value: "working"},
];

export const PAYMENT_METHODS = ["cash", "cheque", "other"];

export const PROJECT_OWNER = [
  {text: "HABIB", value: "habib"},
  {text: "IDM", value: "idm"}
];

export { NATIONALITIES };

// Manpower end

